module.exports = __webpack_public_path__ + "img/fukuinoriko.25b8020a.jpg";